// @flow

"use strict";
import URLUtil from "../../util/url-util";
import OuterWidget from "./outer-widget";

/**
 * DIコンテナ
 */
export default class OuterDIContainer {
  constructor() {}

  static getInstance(): OuterDIContainer{
    const diContainer = new OuterDIContainer();
    // Singleton
    OuterDIContainer.getInstance = function(): OuterDIContainer{
      return diContainer;
    };
    return diContainer;
  }

  /**
   * サイドバーが存在するメディアでbodyなどグローバル領域の要素の縦横幅を元にWidgetのサイズを決められるようにする
   * @param widget
   * @param window
   * @param doc
   */
  handleResizeEvent(widget: OuterWidget ,window: Window, doc: HTMLDocument) {}

  /**
   * 記事URL取得関数
   * デフォルト window.location.href
   * 無限スクロールでwindow.location.href以外から記事URLを組み立てる
   * @param window
   * @param iframeParentDiv
   * @returns {string}
   */
  getURLFunction(window: Window, iframeParentDiv: HTMLDivElement): string {
    return URLUtil.fixedEncodeURIComponent(window.location.href);
  }
}


// WEBPACK FOOTER //
// ./src/js/model/outer/outer-di-container.js